<template>
  <custom-dialog width="1080px" :title="model.title" :visible="visible" v-on="$listeners" :appendToBody="true">
    <div class="dialog-body">
      <el-form :model="form" :inline="true" :rules="rules" ref="form">
        <div class="item-title">{{ $t('crm_step_manage_unified_dialog.she_zhi_zu_lin_jin_e') }}</div>
        <el-row :gutter="10">
          <el-col :span="5" :offset="1">
            <el-form-item :label="$t('crm_step_manage_unified_dialog.she_bei_ya_jin_tai')" prop="depositFee">
              <el-input type="number" :min="0" v-model="form.depositFee" style="width: 205px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('crm_step_manage_unified_dialog.zu_jin')" prop="unitPrice">
              <el-input type="number" :min="0" v-model="form.unitPrice" style="width: 205px" @change="formatPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('crm_step_manage_unified_dialog.shou_hou_fu_jia_fei')" prop="additionalFee">
              <el-input type="number" :min="0" v-model="form.additionalFee" style="width: 205px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('crm_step_manage_unified_dialog.zeng_song_yue_shu')" prop="giveawayMonth">
              <el-input type="number" :min="0" v-model="form.giveawayMonth" style="width: 205px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="item-title">{{ $t('crm_step_manage_unified_dialog.szfcfa') }}</div>
        <div v-for="(item, index) in dataList" :key="index">
          <el-row :gutter="10">
            <el-col :offset="1" :span="10">
              <div style="line-height: 24px; font-size: 12px">{{ item.sharingConditionView }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="1">
              <el-form-item label="" prop="">
                <div style="padding: 28px 0 0 6px; font-weight: 500">
                  {{ item.sharingClass }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('crm_step_manage_unified_dialog.jfdbysy')" prop="agentCoProfit">
                <el-input type="number" :min="0" v-model="item.agentCoProfit" style="width: 100%" @change="formatPrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('crm_step_manage_unified_dialog.shgsys')" prop="afterServiceProfit">
                <el-input type="number" :min="0" v-model="item.afterServiceProfit" style="width: 100%" @change="formatPrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('crm_step_manage_unified_dialog.zbysy')" prop="hqProfit">
                <el-input disabled type="number" :min="0" v-model="item.hqProfit" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('crm_step_manage_unified_dialog.zbysjzy')" prop="hqBasicProfit">
                <el-input type="number" :min="0" v-model="item.hqBasicProfit" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('crm_step_manage_unified_dialog.sqksblx')" prop="firstDeviceBizType">
                <el-select multiple v-model="item.firstDeviceBizType" :placeholder="$t('Common.com_please_select')" style="width: 240px">
                  <el-option v-for="item in bizTypeList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins.js';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';

export default {
  mixins: [languageInjectMixins, dialogMixins],
  data() {
    return {
      form: {
        depositFee: '',
        unitPrice: '',
        additionalFee: '',
        giveawayMonth: '',
      },
      deviceBizTypeList: [],
      dataList: [],
    };
  },
  computed: {
    rules() {
      return {
        depositFee: { required: true, message: this.$t('crm_step_manage_unified_dialog.sbyjbnwk') },
        unitPrice: { required: true, message: this.$t('crm_step_manage_unified_dialog.zjbnwk') },
        additionalFee: { required: true, message: this.$t('crm_step_manage_unified_dialog.shfjfbnwk') },
      };
    },
    bizTypeList() {
      const list = this.dataList.map((t) => t.firstDeviceBizType.join(',')).join(',');
      return this.deviceBizTypeList.filter((t) => !list.includes(t));
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.deviceBizTypeList = Array.from(new Set(this.model.data.deviceBizTypeList));
      this.dataList = JSON.parse(JSON.stringify(this.model.data.itemsForm));
      this.dataList.forEach((row) => {
        row.firstDeviceBizType = this.deviceBizTypeList.includes(row.sharingClass) ? [row.sharingClass] : [];
      });
    },
    // 价格计算
    formatPrice: function () {
      this.dataList.forEach((row) => {
        row.hqProfit = Number.parseFloat(this.form.unitPrice || 0) - Number.parseFloat(row.agentCoProfit || 0) - Number.parseFloat(row.afterServiceProfit || 0);
        row.hqBasicProfit = Number.parseFloat(this.form.unitPrice || 0) - Number.parseFloat(row.agentCoProfit || 0) - Number.parseFloat(row.afterServiceProfit || 0);
      });
      // this.formatFirstBizType();
    },
    // 格式化首期设备类型
    formatFirstBizType: function () {
      // 原来只有AB分成2个方案的设备业务类型 初始化规则
      // 1.A、B类型机器时使用A分成 计算首期款
      // 2.C、D、F类型机器时根据月租金进行判断，月租金匹配A分成规则 则使用A分成 计算首期款，否则使用B分成规则计算首期款
      // const sharingClass = this.dataList.map((t) => t.sharingClass).join(',');
      // if (sharingClass === 'A,B') {
      //   let result = false;
      //   this.dataList.forEach((item) => {
      //     if (item.sharingClass === 'A') {
      //       result = this.computedUnitPrice(item.sharingCondition, this.form.unitPrice);
      //       item.firstDeviceBizType = result ? this.deviceBizTypeList : this.deviceBizTypeList.filter((t) => ['A', 'B'].includes(t));
      //     } else if (item.sharingClass === 'B') {
      //       item.firstDeviceBizType = result ? [] : this.deviceBizTypeList.filter((t) => !['A', 'B'].includes(t));
      //     }
      //   });
      // } else if (sharingClass === 'A,B,C') {
      //   // 原来有ABC 分成3个方案的设备业务类型 初始化规则
      //   // 1.A类型 使用A分成 计算首期款 (未变化)
      //   // 2.B类型使用B分成计算首期款(未变化)
      //   // 3.C、D、F类型机器使用C分成计算首期款
      //   this.dataList.forEach((item) => {
      //     if (item.sharingClass === 'A') {
      //       item.firstDeviceBizType = this.deviceBizTypeList.filter((t) => ['A'].includes(t));
      //     } else if (item.sharingClass === 'B') {
      //       item.firstDeviceBizType = this.deviceBizTypeList.filter((t) => ['B'].includes(t));
      //     } else if (item.sharingClass === 'C') {
      //       item.firstDeviceBizType = this.deviceBizTypeList.filter((t) => !['A', 'B'].includes(t));
      //     }
      //   });
      // }
    },
    // 规则字符串： "(unitPrice >= 830 || totalReceivedRentalHq < 13776)"
    // 连接符： >,!=,>=,<,<=,==
    computedUnitPrice: function (ruleString, num) {
      const regex = /unitPrice\s*([><=!]+)\s*(\d+)/;
      const match = ruleString.match(regex);
      const operator = match[1];
      const value = match[2];
      let result = false;
      if (!operator || !value) {
        return result;
      }
      switch (operator) {
        case '>':
          result = Number(num || '0') > Number(value);
          break;
        case '>=':
          result = Number(num || '0') >= Number(value);
          break;
        case '<':
          result = Number(num || '0') < Number(value);
          break;
        case '<=':
          result = Number(num || '0') <= Number(value);
          break;
        case '!=':
          result = Number(num || '0') !== Number(value);
          break;
        case '==':
          result = Number(num || '0') === Number(value);
          break;
        default:
      }
      return result;
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const hasEmpty = this.dataList.find((t) => !`${t.agentCoProfit}` || !`${t.afterServiceProfit}` || !`${t.hqProfit}`);
        if (hasEmpty) {
          this.$message.error(this.$t('crm_step_manage_unified_dialog.qjxxtxwz'));
          return;
        }
        if (this.bizTypeList.length > 0) {
          this.$message.error(this.$t('crm_step_manage_unified_dialog.qjsqksblxxzwz'));
          return;
        }
        this.visible = false;
        this.$emit('success', { form: this.form, itemsForm: this.dataList });
      });
    },
  },
};
</script>

<style lang="scss"></style>
